import { render, staticRenderFns } from "./syllabus.vue?vue&type=template&id=3189cd4a&scoped=true&"
import script from "./syllabus.vue?vue&type=script&lang=js&"
export * from "./syllabus.vue?vue&type=script&lang=js&"
import style0 from "./syllabus.vue?vue&type=style&index=0&id=3189cd4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3189cd4a",
  null
  
)

export default component.exports